import React, { useState } from 'react';
import { Form } from 'react-form';

import {
    CheckBox,
    Input, PhoneNumber, Select,
} from '../../../components/Form';
import Img from '../../../components/Img';
import { getClickAttrs } from '../../../components/Analytics/gtag';
import { createReactFormValidator, requiredEmail, required, requiredZipCode } from '../../../utils/validation';
import { intlPhoneNumber } from '../../../utils/validation-libdep';
import { getNCSAPlayerGradYearOptions } from '../../../utils';

import styles from '../nuoV2.scss';

const NCSARegistrationForm = props => {
    const { loading, defaultValues, onsubmit, skipForm, hasOptInFormError } = props;
    const gradYearOptions = getNCSAPlayerGradYearOptions();
    const [isShowingForm, setisShowingForm] = useState(false);

    const themeV3 = true;

    return (
        <div className={styles.pageContent}>
            <div className={styles.title} data-testid="nuo-v2.ncsa-registration.title">
                Are you interested in playing college tennis?
            </div>
            <div className={styles.page}>
                <Form
                    onSubmit={values => { onsubmit(values); }}
                    defaultValues={defaultValues}
                >
                    {(formApi) => {
                        const { submitForm } = formApi;
                        return (
                            <form onSubmit={submitForm} skipForm={skipForm}>
                                <div className={`${styles.description} text-dark`}>
                                    <div className={`${styles.images}`}>
                                        <Img
                                            src="/img/utr_sports/utr-sports-logo.svg"
                                            className={`${styles.utrlogo} align-self-start`}
                                            data-testid="nuo-v2.ncsa-registration.utr-logo"
                                        />
                                        <span className="align-self-center">&nbsp; X &nbsp;</span>
                                        <Img
                                            src={'/img/partners/ncsa/ncsa-logo.svg'}
                                            className={`${styles.utrlogo} align-self-start`}
                                            data-testid="nuo-v2.ncsa-registration.ncsa-logo"
                                        />
                                    </div>
                                    <p>
                                        UTR Sports has partnered with NCSA College
                                        Recruiting to help student-athletes with the dream
                                        of playing in college.
                                    </p>
                                    <ul>
                                        <li>Get noticed by 3500 college tennis coaches</li>
                                        <li>Meet with an NCSA expert for a <b>free</b> recruiting assessment</li>
                                        <li>Receive a <b>free</b> personalized recruiting game plan</li>
                                    </ul>
                                    {!isShowingForm && (
                                        <div className="row mt16">
                                            <div className="col-12 col-md-6">
                                                <button
                                                    type="button"
                                                    className="btn btn-default btn-block btn-lg text-uppercase"
                                                    onClick={() => skipForm()}
                                                    data-testid="nuo-v2.ncsa-registration.no-btn"
                                                >
                                                    No
                                                </button>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-block btn-lg text-uppercase"
                                                    data-testid="nuo-v2.ncsa-registration.yes-btn"
                                                    onClick={() => {
                                                        // segment track call - mapped to GA4
                                                        if (window && window.analytics) {
                                                            window.analytics.track('NCSA Onboarding Page Opt In', {
                                                            });
                                                        }
                                                        setisShowingForm(true);
                                                    }}
                                                    {...getClickAttrs({
                                                        category: 'NCSA',
                                                        context: 'NCSA Onboarding Page Opt In',
                                                        location: 'NCSA Reegistration Form',
                                                    })}
                                                >
                                                    Yes
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className={`${isShowingForm ? `form-block-content mt20` : `d-none`}`}>
                                    <p className={styles.description}>Please provide some additional information</p>
                                    <div className={`form-group`}>
                                        <div className="row">
                                            <div className="col-12 form-title">
                                                <label className={`mb16 form-label ${styles.formLabel}`}>
                                                    Additional Player information
                                                </label>
                                            </div>
                                            <div className="col-12">
                                                <Select
                                                    id="gradYear"
                                                    field="athleteGraduationYear"
                                                    validate={required}
                                                    label="High school graduation year"
                                                    options={gradYearOptions}
                                                    hiddenLabel={false}
                                                    themeV3={themeV3}
                                                />
                                            </div>
                                            <div className="col-12">
                                                <Input
                                                    label="Zip code"
                                                    field="zipCode"
                                                    type="text"
                                                    validate={requiredZipCode}
                                                    themeV3={themeV3}
                                                    disableProfanityCheck={true}
                                                />
                                            </div>
                                            <div className="col-12 form-title">
                                                <label className={`mb16 form-label ${styles.formLabel}`}>
                                                    Parent information
                                                </label>
                                            </div>
                                            <div className="col-12">
                                                <Input
                                                    id={`parentLirstNameInput`}
                                                    field={`parentFirstName`}
                                                    validate={required}
                                                    label="Parent first name"
                                                    hiddenLabel={false}
                                                    themeV3={themeV3}
                                                />
                                            </div>
                                            <div className="col-12">
                                                <Input
                                                    id="parentLastNameInput"
                                                    field="parentLastName"
                                                    validate={required}
                                                    label="Parent last name"
                                                    hiddenLabel={false}
                                                    themeV3={themeV3}
                                                />
                                            </div>
                                            <div className="col-12">
                                                <Input
                                                    id={`emailInput`}
                                                    field={`parentEmail`}
                                                    validate={requiredEmail}
                                                    label={'Parent email address'}
                                                    themeV3={themeV3}
                                                    disableProfanityCheck={true}
                                                />
                                            </div>
                                            <div className="col-12">
                                                <PhoneNumber
                                                    label="Parent phone number"
                                                    id="phone"
                                                    field="parentPhone"
                                                    placeholder="(212) 555-5555"
                                                    validate={createReactFormValidator([required, intlPhoneNumber])}
                                                    themeV3={themeV3}
                                                />
                                            </div>
                                            <div className="col-12">
                                                <CheckBox
                                                    id="isParent"
                                                    customLabel="I am the parent of the player"
                                                    field="isParent"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {(hasOptInFormError) && <div className="pb24 text-center text-error text-small" data-testid="nuo-v2.ncsa-registration.error-text">{hasOptInFormError}</div>}
                                    <div>
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-xl text-uppercase btn-block"
                                            disabled={loading}
                                            data-testid="nuo-v2.ncsa-registration.submit-btn"
                                        >
                                            submit
                                        </button>
                                    </div>
                                    <div className={`${styles.skip}`}>
                                        I&apos;ve changed my mind.
                                        <div className={`link clickable d-inline mr32`} onClick={() => skipForm()} data-testid="nuo-v2.ncsa-registration.skip-link"> Skip this.</div>
                                    </div>
                                </div>
                            </form>
                        );
                    }}
                </Form>
            </div>
        </div>
    );
};

export default NCSARegistrationForm;
